import React from 'react';
import { Link, Outlet } from 'react-router-dom';

export function StudioAdminLayout() {
  return (
    <div className="flex h-screen">
      <aside className="w-64 bg-gray-800 text-white p-4">
        <h2 className="text-xl font-bold mb-4">Studio Admin</h2>
        <nav>
          <ul>
            <li><Link to="/studio" className="block py-2">Dashboard</Link></li>
            <li><Link to="/studio/clients" className="block py-2">Clients</Link></li>
            {/* Other nav links will go here */}
          </ul>
        </nav>
      </aside>
      <main className="flex-1 p-8 bg-gray-100 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}